import { Controller } from "@hotwired/stimulus";

// Coordinates are usually copied from Google Maps: the "lat, lng" its
// right-click menu copies, or a whole URL with "@lat,lng,zoom" in it. Pasting
// either into one of the two fields fills both. Anything else is pasted as
// usual, for the server to read or refuse (see CoordinateFields).
export default class extends Controller {
  static targets = ["latitude", "longitude"]

  paste(event) {
    const pair = coordinatesIn(event.clipboardData?.getData("text") ?? "");
    if (!pair) return;

    event.preventDefault();
    this.latitudeTarget.value = pair.latitude;
    this.longitudeTarget.value = pair.longitude;
  }
}

const NUMBER = String.raw`-?\d{1,3}\.\d+`;
// Two numbers and nothing else, apart by a comma, a semicolon or spaces.
const PAIR = new RegExp(String.raw`^\s*(${NUMBER})\s*[,;\s]\s*(${NUMBER})\s*$`);
// In a URL: "…/@-14.57,-54.93,12z…", or "?q=-14.57,-54.93" and
// "query=-14.57%2C-54.93" once decoded.
const IN_URL = new RegExp(String.raw`[@=](${NUMBER}),\s*(${NUMBER})`);

function coordinatesIn(text) {
  let decoded = text;
  try {
    decoded = decodeURIComponent(text);
  } catch {
    // Not URL-encoded after all; read it as it is.
  }

  const match = decoded.match(PAIR) || decoded.match(IN_URL);
  return match && { latitude: match[1], longitude: match[2] };
}
